export default "__VITE_ASSET__D0utn4AP__"